import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import TireTruckImplement from './tire-truck-implement';
import TireTruckImplementDetail from './tire-truck-implement-detail';
import TireTruckImplementUpdate from './tire-truck-implement-update';
import TireTruckImplementDeleteDialog from './tire-truck-implement-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={TireTruckImplementUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={TireTruckImplementUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={TireTruckImplementDetail} />
      <ErrorBoundaryRoute path={match.url} component={TireTruckImplement} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={TireTruckImplementDeleteDialog} />
  </>
);

export default Routes;
